import { configureStore } from '@reduxjs/toolkit'
import { feedbeqApi } from './api'
import uiReducer from '@/features/ui/uiSlice'
import langReducer from '@/features/lang/langSlice'
import authReducer from '@/features/auth/authSlice'
import reportsReducer from '@/features/reports/reportsSlice'
import configReducer from '@/features/config/configSlice'
import { jiraReducer } from '@/features/jira'

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    lang: langReducer,
    auth: authReducer,
    reports: reportsReducer,
    config: configReducer,
    jira: jiraReducer,
    [feedbeqApi.reducerPath]: feedbeqApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // 🚀 PERFORMANCE: Optimize middleware for better performance
      immutableCheck: { warnAfter: 64 },
      serializableCheck: {
        ignoredActions: [`${feedbeqApi.reducerPath}/executeMutation/pending`],
        warnAfter: 64,
      },
    }).concat(feedbeqApi.middleware),
  devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Typed hooks
export { useAppDispatch, useAppSelector } from './hooks' 